import moment from "moment";

export const entityCustomFieldValueComponent = {
  templateUrl: "admin/views/entity-custom-field-value-component.html",
  bindings: {
    customField: "<",
    initData: "<",
  },
  //! @ngInject
  controller: function ($rootScope, DatabaseApi, caregiverLookupService, patientLookupService) {
    this.initOptions = () => {
      if (this.initData) {

        if (this.customField) {
          switch (this.customField.fieldType) {
            case "TEXT":
            case "NUMBER":
            case "ADDRESS":
            case "PHONE_NUMBER":
            case "ENUM":
            case "BOOLEAN":
              this.customField.value = this.customField.value;
              break;
            case "DATE":
              this.customField.date = new Date(
                moment(this.customField.value).format("MM/DD/YYYY")
              );
              break;
            case "DATE_RANGE":
              if (!this.customField.range) {
                this.customField.range = {};
              }
              this.customField.from = new Date(
                moment(this.customField.from).format("MM/DD/YYYY")
              );
              this.customField.to = new Date(
                moment(this.customField.to).format("MM/DD/YYYY")
              );
              this.customField.range.startDate = this.customField.from;
              this.customField.range.endDate = this.customField.to;
              break;
            case "CAREGIVER":
              if (this.customField.value.displayName === undefined) {
                caregiverLookupService.byId(this.customField.value).then((caregiver) => {
                  if (caregiver !== null) this.customField.value = caregiver;
                });
              }
              break;
            case "PATIENT":
              if (this.customField.value.displayName === undefined) {
                patientLookupService.byId(this.customField.value).then((patient) => {
                  if (patient !== null) this.customField.value = patient;
                });
              }
              break;
            default:
              break;
          }
        }
      }
    };

    this.$onInit = () => {
      this.initOptions();
    };

    $rootScope.$on("got_data", () => {
      this.initOptions();
    });
  },
};
